(function() {
  "use strict";

  angular.module("PrintixInfoNetwork", [])

    .constant("PrintixNetworkInfoConstants", {
      SHOW: "network_info_show",
      HIDE: "network_info_hide"
    })

    .constant("PrintixNetworkInfoSelectors", {
      MODAL_ID: "infoNetworkModal",
      CONFIRM_BUTTON_CSS_CLASS: "confirm-button"
    })


    .controller("InfoNetworkController", ["$rootScope", "$scope", "$location", "URLS", "PRINTER_STATUSES", "PrintixNetworkInfoConstants",
      "PrintixNetworkInfoSelectors",
      function($rootScope, $scope, $location, URLS, PRINTER_STATUSES, PrintixNetworkInfoConstants,
        PrintixNetworkInfoSelectors) {

        $scope.network = null;
        $scope.networkInfoModalId = PrintixNetworkInfoSelectors.MODAL_ID;

        $scope.clearNetworkInfo = function() {
          if ($scope.network) {
            $scope.network = null;
          }
        };

        var locationChangeListener = function(){};
        $scope.showNetworkInfo = function(network) {
          if (network) {
            $scope.network = angular.copy(network);
            var networkModal = angular.element("#" + $scope.networkInfoModalId);
            networkModal.modal("show");
            locationChangeListener = $rootScope.$on('$locationChangeStart', function() {
              networkModal?.modal("hide");
            })
          } else {
            throw "$scope.showNetworkInfo: network is missing";
          }
        };

        var SHOW_listener = $rootScope.$on(PrintixNetworkInfoConstants.SHOW, function(name, network) {
          $scope.showNetworkInfo(network);
        });

        $scope.$on("$destroy", function() {
          SHOW_listener();
          locationChangeListener();
        });
      }
    ])

    .directive("infoNetworkObjectControl", ["$rootScope", "PrintixNetworkInfoSelectors", "PrintixNetworkInfoConstants",
      function($rootScope, PrintixNetworkInfoSelectors, PrintixNetworkInfoConstants) {
        return {
          link: function($scope, element, attrs) {
            element.on("hide.bs.modal", function() {
              $scope.clearNetworkInfo(angular.element(document.activeElement).hasClass(PrintixNetworkInfoSelectors.CONFIRM_BUTTON_CSS_CLASS));
            });
            var HIDE_listener = $rootScope.$on(PrintixNetworkInfoConstants.HIDE, function() {
              element.modal("hide");
            });
            $scope.$on("$destroy", function() {
              HIDE_listener();
            });
          }
        };
      }
    ]);
})();
